import { arrayUtils } from "@zickko/shared";
import { Result } from "nutso";
import { ReactNode } from "react";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

export type FormListInlineProps<T> = FormItemProps<T[]> & {
  value: T[] | undefined;
  add: () => T;
  onChange: (value: T[]) => void;
  children: (args: {
    item: T;
    index: number;
    validation?: Result<T>;
    onChange: (value: T) => void;
    onDelete: () => void;
  }) => ReactNode;
};

export const FormListInlineContainer = <T,>(props: FormListInlineProps<T>) => {
  const { value = [], add } = props;
  return (
    <FormItemContainer<T[]> {...props}>
      {value.map((item, index) =>
        props.children({
          item,
          index,
          onChange: (update) => props.onChange(arrayUtils.replace(value, index, update)),
          validation: props.validation?.items[index],
          onDelete: () => props.onChange(arrayUtils.remove(value, index)),
        })
      )}
      <button type="button" onClick={() => props.onChange([...value, add()])}>
        Add
      </button>
    </FormItemContainer>
  );
};
